import { type FC } from 'react';
import { ToolNavigationList } from './ToolNavigationList';
import { useToolNavigationDataProvider } from './ToolNavigationDataProvider';
import { useToolNavigationRoleSwitcherProvider } from './ToolNavigationRoleSwitcherProvider';
import { ToolNavigationRoleSwitcher } from './ToolNavigationRoleSwitcher';
import { ToolNavigationFooter } from './ToolNavigationFooter';
import classes from '../styles/index.module.css';

export const ToolNavigationContent: FC = () => {
	const { isAdmin } = useToolNavigationRoleSwitcherProvider();
	const navData = useToolNavigationDataProvider();
	const adminNavigationItems = navData?.adminNavigationItems || [];
	const userNavigationItems = navData?.userNavigationItems || [];

	return (
		<div className={classes.toolNavigation__content}>
			<ToolNavigationRoleSwitcher />
			<ToolNavigationList
				items={isAdmin ? adminNavigationItems : userNavigationItems}
				dataTestId={`tool-navigation-${isAdmin ? 'admin' : 'user'}-list`}
			/>
			<ToolNavigationFooter />
		</div>
	);
};
